module.exports = __webpack_public_path__ + "images/card-americanexpress.c5d7d76d2ab8202a3ec278d28bbc54ed.svg";